import { baseURL, commonHeader, userLogCommonHeader } from "api/constants";
import { POLYLINE_MODE } from "redux/tools/enums";

export function savePolylineAPI({ sourceId, labelId, dataPoint }) {
  return fetch(`${baseURL}/labelPolyline`, {
    method: "POST",
    ...userLogCommonHeader,
    headers: {
      ...userLogCommonHeader.headers,
      type: POLYLINE_MODE,
    },
    body: JSON.stringify({
      sourceId,
      labelId,
      dataPoint,
    }),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.log(error, "error");
      return { error: true, ...error };
    });
}

export function updatePolylineAPI({ id, sourceId, dataPoint, labelId }) {
  return fetch(`${baseURL}/labelPolyline/${id}`, {
    method: "PUT",
    ...commonHeader,
    body: JSON.stringify({
      sourceId,
      dataPoint,
      labelId,
    }),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.log(error, "error");
      return { error: true, ...error };
    });
}
